import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-accordion", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion>
            <div slot="title">Title</div><p>Content</p>
        </ux-accordion>`);
        const el = await page.find("ux-accordion");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should open and close on click", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-accordion>
            <div slot="title">Title</div><p>Content</p>
        </ux-accordion>`);
        await page.waitForChanges();
        const titleContanier = await page.find(
            ".ux-accordion__title-container"
        );
        const accordion = await page.find(".ux-accordion.hydrated");
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
        await titleContanier.click();
        await page.waitForChanges();
        expect(accordion).toHaveAttribute("is-expanded");
        await titleContanier.click();
        await page.waitForChanges();
        expect(accordion).not.toHaveAttribute("is-expanded");
    });

    it("should have theme class", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-accordion class="ux-accordion--grey-shadow"></ux-accordion>`
        );
        const el = await page.find("ux-accordion");
        expect(el).toHaveClass("ux-accordion--grey-shadow");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-accordion>
            <div slot="title">Title</div><p>Content</p>
        </ux-accordion>`);
    });
});
